// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-img {
    width: 100%;
    border-radius: 8px;
}
.swiper-pagination {
    text-align: center;
}
.swiper-pagination-bullet {
    background-color: #16a34a;
    transition: 0.5s;
}
.swiper-pagination-bullet-active {
    width: 40px;
    height: 10px;
    border-radius: 5px;
}
#hero {
    position: relative;
}
#hero:before {
    content: "";
    position: absolute;
    background-color: var(--main-color);
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
}
 @keyframes up-down {
    0% {
      transform: translateY(10px);
    }
  
    100% {
      transform: translateY(-10px);
    }
  }
  .hero-waves {
    display: block;
    width: 100%;
    height: 70px;
    /* margin-top: 60px; */
    z-index: 5;
    position: relative;
  }
  
  .wave1 use {
    animation: move-forever1 10s linear infinite;
    animation-delay: -2s;
  }
  
  .wave2 use {
    animation: move-forever2 8s linear infinite;
    animation-delay: -2s;
  }
  
  .wave3 use {
    animation: move-forever3 6s linear infinite;
    animation-delay: -2s;
  }
  
  @keyframes move-forever1 {
    0% {
      transform: translate(85px, 0%);
    }
  
    100% {
      transform: translate(-90px, 0%);
    }
  }
  
  @keyframes move-forever2 {
    0% {
      transform: translate(-90px, 0%);
    }
  
    100% {
      transform: translate(85px, 0%);
    }
  }
  
  @keyframes move-forever3 {
    0% {
      transform: translate(-90px, 0%);
    }
  
    100% {
      transform: translate(85px, 0%);
    }
  }`, "",{"version":3,"sources":["webpack://./src/assets/styles/Banner.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,mCAAmC;IACnC,SAAS;IACT,MAAM;IACN,OAAO;IACP,QAAQ;AACZ;CACC;IACG;MACE,2BAA2B;IAC7B;;IAEA;MACE,4BAA4B;IAC9B;EACF;EACA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,4CAA4C;IAC5C,oBAAoB;EACtB;;EAEA;IACE,2CAA2C;IAC3C,oBAAoB;EACtB;;EAEA;IACE,2CAA2C;IAC3C,oBAAoB;EACtB;;EAEA;IACE;MACE,8BAA8B;IAChC;;IAEA;MACE,+BAA+B;IACjC;EACF;;EAEA;IACE;MACE,+BAA+B;IACjC;;IAEA;MACE,8BAA8B;IAChC;EACF;;EAEA;IACE;MACE,+BAA+B;IACjC;;IAEA;MACE,8BAA8B;IAChC;EACF","sourcesContent":[".banner-img {\n    width: 100%;\n    border-radius: 8px;\n}\n.swiper-pagination {\n    text-align: center;\n}\n.swiper-pagination-bullet {\n    background-color: #16a34a;\n    transition: 0.5s;\n}\n.swiper-pagination-bullet-active {\n    width: 40px;\n    height: 10px;\n    border-radius: 5px;\n}\n#hero {\n    position: relative;\n}\n#hero:before {\n    content: \"\";\n    position: absolute;\n    background-color: var(--main-color);\n    bottom: 0;\n    top: 0;\n    left: 0;\n    right: 0;\n}\n @keyframes up-down {\n    0% {\n      transform: translateY(10px);\n    }\n  \n    100% {\n      transform: translateY(-10px);\n    }\n  }\n  .hero-waves {\n    display: block;\n    width: 100%;\n    height: 70px;\n    /* margin-top: 60px; */\n    z-index: 5;\n    position: relative;\n  }\n  \n  .wave1 use {\n    animation: move-forever1 10s linear infinite;\n    animation-delay: -2s;\n  }\n  \n  .wave2 use {\n    animation: move-forever2 8s linear infinite;\n    animation-delay: -2s;\n  }\n  \n  .wave3 use {\n    animation: move-forever3 6s linear infinite;\n    animation-delay: -2s;\n  }\n  \n  @keyframes move-forever1 {\n    0% {\n      transform: translate(85px, 0%);\n    }\n  \n    100% {\n      transform: translate(-90px, 0%);\n    }\n  }\n  \n  @keyframes move-forever2 {\n    0% {\n      transform: translate(-90px, 0%);\n    }\n  \n    100% {\n      transform: translate(85px, 0%);\n    }\n  }\n  \n  @keyframes move-forever3 {\n    0% {\n      transform: translate(-90px, 0%);\n    }\n  \n    100% {\n      transform: translate(85px, 0%);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
